var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('nav-select',{attrs:{"users":_vm.getListChildrenSelectFormat},on:{"onChangeAction":_vm.handleChildChange}}),_c('nav-subtitle',{staticClass:"mb-3",attrs:{"title":'Check child challenge',"icon":'playlist_add_check'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }